// ════════════════════════════════════════════════════════════════════════
// PLAN YUKLEME HATA METINLERI — TEK KAYNAK (30 Agu 2026)
//
// 🔑 Serkan: *"Plan yukleme sirasinda sorun olursa bir METIN ciksin ve sorunu
// soylesin. Error kod vermesin, koddan bir sey anlamiyoruz; metin gelirse
// anlariz, tekrar bir ikinci yanlisa dusmeyiz."*
//
// 🔴 NEDEN: 27 Agu'da `REFRESH FAILED (400)` bir PDF hatasi DEGILDI, kimlik
// reddiydi — ama ekran "plani yeniden yukleyin" dedigi icin Serkan plani IKI
// KEZ yukledi. Yani mesaj yalniz anlasilmaz degildi, YANLIS ISE YONLENDIRDI.
// Bu yuzden her metin IKI parca tasir: NE OLDU + NE YAPMALI. Ikincisi
// olmayan mesaj, kullaniciyi kendi tahminine birakir.
//
// Metinler INGILIZCE (Serkan, 30 Agu) — ekranin geri kalaniyla ayni dil.
// Ham teknik metin EKRANDA GORUNMEZ; `detail` alaninda doner ve arayuz onu
// "TECHNICAL DETAIL" olarak katlanmis, kopyalanabilir tutar (destek icin
// gerekli — kodu tamamen atmak teshisi tekrar tahmine dusururdu).
//
// SINIFLANDIRMA SIRASI ONEMLI: sunucunun kendi acikladigi durumlar (baska
// operator, tescil okunamadi) once yakalanir; genel HTTP kodlari sonra.
// ════════════════════════════════════════════════════════════════════════

/** Sunucunun zaten INSAN CUMLESI olarak yazdigi hatalar — oldugu gibi gecer. */
const SUNUCU_CUMLESI = [
  /belongs to another operator/i,     // tescil baska sirkete kayitli
  /is not registered to any company/i,
  /Registration could not be read/i,
];

/**
 * Yukleme basarisizligini pilotun/dispatcher'in anlayacagi metne cevirir.
 *
 * @param {{status?: number, serverError?: string, networkError?: Error}} x
 * @returns {{text: string, detail: string}}
 *   text   — ekranda gosterilecek cumle (NE OLDU + NE YAPMALI)
 *   detail — ham teknik metin; ekranda DEGIL, katlanmis "technical detail"de
 */
export function uploadErrorMessage({ status, serverError, networkError } = {}) {
  const ham = String(serverError ?? networkError?.message ?? '').trim();
  const detail = [status ? `HTTP ${status}` : null, ham || null]
    .filter(Boolean).join(' · ') || 'no detail available';
  const ver = (text) => ({ text, detail });

  // ── 1) AG YOK: istek sunucuya hic ulasmadi ──────────────────────────────
  // Dosya kaybolmadi — bunu SOYLEMEK onemli, yoksa yukleme bastan yapilir.
  if (networkError && !status) {
    return ver('Could not reach the server. Check your internet connection and try again — the file was not lost.');
  }

  // ── 2) SUNUCU ZATEN ACIKLAMIS ───────────────────────────────────────────
  if (SUNUCU_CUMLESI.some((k) => k.test(ham))) return ver(ham);

  // ── 3) KIMLIK / YETKI ───────────────────────────────────────────────────
  // 🔴 Buradaki cumle 27 Agu dersinin karsiligi: sorun DOSYADA DEGIL.
  if (status === 401 || /invalid token|missing authorization|session/i.test(ham)) {
    return ver('Your session has expired. Sign out and sign in again — there is nothing wrong with the plan file.');
  }
  if (status === 403) {
    return ver('Your account is not linked to a company, so the plan cannot be filed. Ask your administrator to check your profile. The plan was not uploaded.');
  }

  // ── 4) BELGE OKUNAMADI ──────────────────────────────────────────────────
  if (status === 422 || /no flight sectors/i.test(ham)) {
    return ver('No flight sectors could be read from this PDF. Make sure it is the OFP briefing package and not another document. The plan was not uploaded.');
  }
  if (/pdf_base64 required|could not read the file/i.test(ham)) {
    return ver('The selected file could not be read. Try selecting the PDF again.');
  }

  // ── 5) SUNUCU KAYDEDEMEDI ───────────────────────────────────────────────
  // Dosya dogru, hata bizde. "Tekrar dene" demek dogru; "dosyayi kontrol et"
  // demek YANLIS YONLENDIRME olurdu.
  if (status === 500 || /lookup failed|insert failed/i.test(ham)) {
    return ver('The server could not save the plan. The document is fine — wait a moment and try again. If it keeps happening, report it to us with the technical detail below.');
  }

  // ── 6) SINIFLANDIRAMADIK ────────────────────────────────────────────────
  // Ilke 1: bilmedigimizi bilirmis gibi yapmayiz. "Su yuzden oldu" diye bir
  // sebep UYDURMAK, yanlis ise yonlendirmenin ta kendisidir.
  return ver('The plan could not be uploaded and the reason was not recognised. Please report it to us with the technical detail below.');
}
